import { Node, Schema } from '@tiptap/pm/model'
import { getTextSerializersFromSchema, Range, TextSerializer } from '@tiptap/core'
import { TextMapping } from './TextMapping'

type TextMapperOptions = {
    schema?: Schema
    blockSeparator?: string
    textSerializers?: Record<string, TextSerializer>
}

export class TextMapper {
    private textToModelMapping?: number[]
    private blockSeparator: string
    private textSerializers?: Record<string, TextSerializer>

    constructor(document: Node, _text: string, options?: TextMapperOptions) {

        const { schema, blockSeparator, textSerializers } = options || {}

        this.blockSeparator = blockSeparator || "\n\n"
        this.textSerializers = {
            ...(textSerializers || {}),
            ...(schema ? getTextSerializersFromSchema(schema) : {}),
        }

        const textMapping = new TextMapping(this.blockSeparator.length!)

        const result = this.mapTextToModel(document, textMapping)

        this.textToModelMapping = []
        const keys = [...result.mappings.keys()]
        keys.forEach(k => {
            this.textToModelMapping![k] = result.mappings.get(k)!
        })
    }

    getTextToModelMapping(): number[] {
        return Array.from(this.textToModelMapping!)
    }

    getRange(textOffset: number, length: number): Range|undefined {
        const mapping = this.getTextToModelMapping()

        if (mapping[textOffset] && (textOffset + length) <= mapping.length) {
            return {
                from: mapping[textOffset],
                to: mapping[textOffset + length - 1] + 1
            }
        }
        console.warn(`Failed to get Range for textOffset: ${textOffset} and lenght ${length}`)
        return
    }

    public getTextOffset(modelOffset: number): number {
        const textOffset = this.textToModelMapping!.findIndex(e => e >= modelOffset)
        return textOffset
    }

    private mapTextToModel(node: Node, textMapping: TextMapping): TextMapping {
        const textSerializer = this.textSerializers?.[node.type.name]

        if (textSerializer) {
            if (node.isBlock) {
                textMapping.separateIfNeeded()
            }
            
            const text = serialize(textSerializer, node, textMapping.modelIndex) 
            
            textMapping.increaseSerializedText(text.length, node.nodeSize)
            textMapping.pendingSeparation = true
        } else if (node.isText) {
            textMapping.mapText(node.text!)
        } else if (node.isBlock) {
            textMapping.startBlock()

            if (node.content.childCount > 0) {
                for (let i = 0; i < node.content.childCount; i++) {
                    textMapping = this.mapTextToModel(node.content.child(i), textMapping)
                }
            } else if (node.content.childCount == 0) {
                textMapping.pendingSeparation = true
            }
            
            textMapping.endBlock()
        } else {
            textMapping.increaseModel(node.nodeSize)
            textMapping.pendingSeparation = true
        }
        return textMapping
    }
}

function serialize(textSerializer: TextSerializer, node: Node, pos: number) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return textSerializer({ node, pos, parent: undefined, index: undefined, range: undefined })
}

